import { translateX } from 'utils/helpers';
import appService from 'services/appService';
import { Flex, Table, Tag } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { FormButton, JarvislyEditViewRemoveItem } from 'components/jarvisly-components/others/FormComponents';
import axiosService from 'services/axiosService';

// COMPONENT *******************************************************************
// *****************************************************************************
const BlockTab = props => {
  // providers context ---------------------------------------------------------

  // props deconstruction ------------------------------------------------------
  const {
    setShowParametersModal,
    setSelectedRecord,
    refreshParameters,
    parameters,
    isWorking,
    setIsWorking,
    mode,
  } = props;

  // local variables I ----------------------------------------------------------
  const isDisabled = isWorking || mode === 'view';

  const tableColumns = buildTableColumns();

  // component states -----------------------------------------------------------

  // local variables II ---------------------------------------------------------

  // hooks ---------------------------------------------------------------------

  // METHODS -------------------------------------------------------------------
  const onAdd = () => {
    setShowParametersModal(true);
  };
  const onEdit = record => {
    setSelectedRecord(record);
    setShowParametersModal(true);
  };

  const onDelete = async record => {
    setIsWorking(true);
    const axiosOptions = {
      url: `/v1/units-parameters/add-to-set/${parameters?._id}/$pull/blocks._id`,
      data: {
        _id: record?._id,
      },
    };

    appService.message('s', 'saved_parameters', 'onSave');
    await axiosService.put(axiosOptions);

    refreshParameters(true);
  };

  // local variables III --------------------------------------------------------

  // UI COMPONENT --------------------------------------------------------------
  return (
    <>
      <Table
        rowKey="_id"
        columns={tableColumns.filter(x => !x.hidden)}
        dataSource={parameters?.blocks || []}
        pagination={false}
        disabled={false}
      />

      <Flex justify="center">
        <FormButton
          title="add_block"
          className="m-3"
          style={{ width: 'fit-content' }}
          icon={<PlusOutlined />}
          disabled={isDisabled}
          onClick={onAdd}
        />
      </Flex>
    </>
  );

  // INTERNAL FUNCTIONS ========================================================
  // ===========================================================================
  function buildTableColumns() {
    return [
      {
        title: translateX('name'),
        dataIndex: 'name',
        className: 'text-truncate',
        render: (_, record) => {
          return (
            <Tag key={record._id} color={record?.backColor}>
              <span
                className="text-uppercase"
                style={{ color: record?.foreColor }}
              >
                {record?.name}
              </span>
            </Tag>
          );
        },
      },
      {
        title: translateX('abbreviation'),
        dataIndex: 'abbreviation',
        render: (_, record) => {
          return (
            <>
              <div>{record?.abbreviation}</div>
            </>
          );
        },
      },
      {
        title: translateX('floors'),
        dataIndex: 'floors',
        render: (_, record) => {
          return (
            <>
              <div>{record?.floors}</div>
              {/* <div>{record?.floors}</div> */}
            </>
          );
        },
      },

      {
        title: translateX('actions'),
        dataIndex: 'actions',
        width: 120,
        className: 'text-center',
        render: (_, record) => {
          return (
            <JarvislyEditViewRemoveItem
              onEdit={onEdit}
              onDelete={onDelete}
              record={record}
              isDisabled={isDisabled}
              deleteTitle={translateX(
                'remove_this_item',
                ['%ITEM%'],
                ['contact'],
              )}
            />
          );
        },
      },
    ].filter(x => !x.hidden);
  }
};

export default BlockTab;
